import { Check } from "lucide-react";
import { SectionHead, Stagger, StaggerItem, Reveal } from "@/lib/motion";
import { scrollToTarget } from "@/components/SmoothScroll";

const SERVICES = [
  {
    num: "01",
    title: "Gestion des ressources humaines",
    text: "Organisation, recrutement, contrats, suivi du personnel et gestion externalisée de vos RH et de votre paie, avec notre solution GRH & PAIE.",
    link: "#boussole",
    linkLabel: "GRH & PAIE",
  },
  {
    num: "02",
    title: "Comptabilité & gestion de paie",
    text: "Tenue des comptes, états financiers, bulletins de paie et déclarations sociales.",
  },
  {
    num: "03",
    title: "Informatisation",
    text: "Mise en place d'outils et de systèmes informatiques adaptés aux entreprises et institutions.",
  },
  {
    num: "04",
    title: "Assistance en fiscalité",
    text: "Déclarations, conformité, optimisation et accompagnement lors des contrôles.",
  },
  {
    num: "05",
    title: "Formations",
    text: "Formations certifiantes en gestion des ressources humaines, paie, fiscalité et recouvrement, pour étudiants et salariés.",
    link: "#formations",
    linkLabel: "Voir les formations",
  },
];

const INCLUDED = [
  "Établissement des bulletins de paie",
  "Déclarations sociales (CNPS) et fiscales",
  "Contrats de travail et formalités d'embauche et de départ",
  "Administration et dossiers du personnel",
  "Suivi des congés, des absences et des présences",
  "Conseil en conformité avec la réglementation du travail",
];

export default function Services() {
  return (
    <section id="services" className="relative py-24 md:py-32">
      <div className="mx-auto max-w-6xl px-5">
        <SectionHead
          tag="Nos services"
          title="Un accompagnement complet, adapté à votre secteur et à votre taille."
        />
        <Stagger className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {SERVICES.map((s) => (
            <StaggerItem key={s.num} className="h-full">
              <article
                className="group flex h-full flex-col rounded-2xl border border-white/10 border-t-2 border-t-korban-gold bg-white/[0.04] p-7 transition-all duration-300 hover:-translate-y-1.5 hover:border-korban-gold/40 hover:bg-white/[0.07]"
                data-testid={`service-card-${s.num}`}
              >
                <span className="font-display text-4xl font-black text-korban-gold/80 transition-colors group-hover:text-korban-gold">
                  {s.num}
                </span>
                <h3 className="mt-5 font-display text-xl font-semibold leading-snug text-white">{s.title}</h3>
                <p className="mt-3 flex-1 text-[0.93rem] leading-relaxed text-slate-300">{s.text}</p>
                {s.link && (
                  <a
                    href={s.link}
                    onClick={(e) => {
                      e.preventDefault();
                      scrollToTarget(s.link);
                    }}
                    className="mt-5 text-sm font-bold text-korban-blue transition-colors hover:text-korban-gold"
                  >
                    {s.linkLabel}
                  </a>
                )}
              </article>
            </StaggerItem>
          ))}
        </Stagger>

        <Reveal delay={0.1} className="mt-14">
          <div className="rounded-2xl border border-white/10 border-l-4 border-l-korban-gold bg-white/[0.04] p-8 md:p-10">
            <h3 className="font-display text-2xl font-semibold text-white">
              Gestion externalisée des RH et de la paie
            </h3>
            <p className="mt-2 text-slate-300">Ce que nous prenons en charge à votre place :</p>
            <ul className="mt-7 grid gap-x-8 gap-y-3.5 sm:grid-cols-2">
              {INCLUDED.map((item) => (
                <li key={item} className="flex items-start gap-3 text-[0.95rem] text-slate-200">
                  <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-korban-blue/20">
                    <Check size={12} className="text-korban-gold" />
                  </span>
                  {item}
                </li>
              ))}
            </ul>
            <a
              href="#contact"
              onClick={(e) => {
                e.preventDefault();
                scrollToTarget("#contact");
              }}
              data-testid="services-devis-button"
              className="mt-8 inline-flex items-center gap-2 rounded-md bg-korban-gold px-7 py-3.5 font-bold text-korban-navy transition-all hover:-translate-y-0.5 hover:bg-korban-golddark"
            >
              Demander un devis
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
